export function template(tpl, data) {
    var re = /:(\S+)/g;
    var match;

    while ( match = re.exec(tpl) ) {
        console.log(match);
        tpl = tpl.replace(match[0], data[match[1]])
    }

    return tpl;
}

export const capitalize = (str) => {
    if(typeof str === 'string') {
        return str.replace(/^\w/, c => c.toUpperCase());
    } else {
        return '';
    }
};